export default {
  loading: false,
  screenerTemplates: [],
  screenerTemplate: {},
  pagination: {},
  screenerTemplatesParticipants: [],
}
